<template>
  <div>
    <embedded-header></embedded-header>
    <div class="container pt-3">

    <link-save-form
      @saved="saveLink"
      :defaultTitle="defaultTitle"
      :defaultUrl="defaultUrl"
      :defaultTags="defaultTags"
      :defaultSuggestedTags="defaultSuggestedTags"
      :defaultPreviewImageUrl="defaultPreviewImageUrl"
      :saveInProgress="saveRequestInProgress"
      loadMetadata="auto">
    </link-save-form>

    </div>
  </div>
</template>

<script>
import EmbeddedHeader from "@/components/EmbeddedHeader";
import BackendClient from "@/rest/backend-client";
import LinkSaveForm from "@/components/LinkSaveForm";
export default {
  name: "EmbeddedForm",
  head: {
    title: 'just bookmark it! - save bookmark'
  },
  components: {EmbeddedHeader, LinkSaveForm},
  props: ["defaultTitle", "defaultUrl", "defaultSuggestedTags", "defaultPreviewImageUrl"],
  data() {
    return {
      defaultTags: [],
      backendClient: new BackendClient(),
      saveRequestInProgress: false
    }
  },
  methods: {
    async saveLink(event) {
      this.saveRequestInProgress = true;
      try {
        await this.backendClient.saveLink(event.url, event.title, event.tags, event.visibility, event.previewImageUrl);
      } finally {
        this.saveRequestInProgress = false;
      }
      this.$router.push({ name: "embeddedOkThxBai"});
    }
  }
}
</script>

<style scoped>
</style>
